import { formatDate } from "helpers/Helpers";

function stripReportEndOfDay(value: string): string {
  return value.replace(/ 23:59:\d{2}$/, "");
}

function parseDateParam(value: string): Date {
  const parsed = new Date(stripReportEndOfDay(value));
  return Number.isNaN(parsed.getTime()) ? new Date() : parsed;
}

export function mapReportRunParamsToState(params: Record<string, unknown>): Record<string, unknown> {
  const statePatch: Record<string, unknown> = {};

  if (Array.isArray(params.date_range)) {
    const dateRange = params.date_range as string[];
    const startValue = dateRange[0] ?? formatDate(new Date());
    const endValue = stripReportEndOfDay(dateRange[1] ?? startValue);

    statePatch.date_range = dateRange;
    statePatch.dateRangeStart = parseDateParam(startValue);
    statePatch.dateRangeEnd = parseDateParam(endValue);
  }

  if (typeof params.date === "string") {
    statePatch.date = params.date;
    statePatch.singleDate = parseDateParam(params.date);
  }

  const directKeys = [
    "register_ids",
    "sales_channels",
    "vendor_ids",
    "department_ids",
    "category_ids",
    "subcategory_ids",
    "user_ids",
    "customer_types",
    "customer_type_ids",
    "facility_id",
    "facility_ids",
    "form_id",
    "register_id",
    "kitchen_grat",
    "bar_grat",
    "support_grat",
    "zero_balance",
    "selected_days",
    "time_range",
    "types",
    "compare_date_range",
    "customer_payment_methods",
    "gift_cards",
    "rain_checks",
    "credit_books",
    "house_accounts",
  ];

  directKeys.forEach(key => {
    if (params[key] !== undefined) {
      statePatch[key] = params[key];
    }
  });

  if (params.include_zero_balances !== undefined) {
    statePatch.includeBalancesUnder0 = params.include_zero_balances;
  }

  if (params.include_closed_accounts !== undefined) {
    statePatch.includeClosedAccounts = params.include_closed_accounts;
  }

  if (params.includeBalancesUnder0 !== undefined) {
    statePatch.includeBalancesUnder0 = params.includeBalancesUnder0;
  }

  return statePatch;
}
